import React, { Suspense } from 'react';
import CircularProgress from '../../../components_base/CircularProgress';

const OrderList = React.lazy(() => import('../components/OrderList'));
function OrderListView(params: any) {
  return (
    <Suspense fallback={<CircularProgress />}>
      <OrderList {...params} />
    </Suspense>
  );
}

export default OrderListView;
